module.exports = __webpack_public_path__ + "static/media/3.c2d6caa3.png";